import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    getCartAuditFn,
    getOrderApprovalNotesFn,
    loadOrderApprovalNotesParams,
    WebAuditResponseModel,
} from "@tKgpco/Services/OrderApprovalService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<loadOrderApprovalNotesParams, WebAuditResponseModel[]>;

export const RequestgetWebCartAudit: HandlerType = async props => {
    const result = await getCartAuditFn(props.parameter);

    if (result.length) {
        props.apiResult = result;
        props.parameter?.onSuccess?.(result);
    } else {
        props.parameter?.onError?.("No notes found for this order.");
        return false;
    }
};

export const chain = [RequestgetWebCartAudit];
const getWebCartAudit = createHandlerChainRunner(chain, "getWebCartAudit");
export default getWebCartAudit;
